export const isDealerCashVehicle = (dataSource?: string) => {
  return dataSource === 'TSP';
};
